import { http } from '../index'

// 留言相关接口类型定义
export interface Message {
  id: number
  name: string
  phone_email: string
  content: string
  ip_address?: string
  user_agent?: any
  reply_content?: string
  items: string
  status: string
  slug?: string
  creator?: {
    id: number
    name: string
  }
  created_at: string
  updated_at: string
}

export interface MessageListParams {
  page?: number
  per_page?: number
  keyword?: string
  status?: string
  items?: string
  sort_field?: string
  sort_order?: string
}

export interface MessageCreateData {
  name: string
  phone_email: string
  content: string
  ip_address?: string
  user_agent?: any
  reply_content?: string
  items: string
  status: string
  slug?: string
}

export interface MessageUpdateData extends Partial<MessageCreateData> {}

// 回复留言数据
export interface MessageReplyData {
  reply_content: string
}

// 留言API
export const messageApi = {
  // 获取留言列表
  list: (params: MessageListParams = {}) => {
    return http.get('messages', { params })
  },

  // 获取统计数据
  statistics: () => {
    return http.get('messages/statistics')
  },

  // 获取留言详情
  detail: (id: number) => {
    return http.get(`messages/${id}`)
  },

  // 删除留言
  delete: (id: number) => {
    return http.delete(`messages/${id}`)
  },

  // 回复留言
  reply: (id: number, data: MessageReplyData) => {
    return http.post(`messages/${id}/reply`, data)
  },

  // ==================== 以下为扩展功能（如果后端支持） ====================

  // 创建留言
  create: (data: MessageCreateData) => {
    return http.post('messages', data)
  },

  // 更新留言
  update: (id: number, data: MessageUpdateData) => {
    return http.put(`messages/${id}`, data)
  },

  // 更新留言状态
  updateStatus: (id: number, status: string) => {
    return http.patch(`messages/${id}/status`, { status })
  },

  // 批量删除
  batchDelete: (ids: number[]) => {
    return http.post('messages/batch-delete', { ids })
  },

  // 批量更新状态
  batchUpdateStatus: (ids: number[], status: string) => {
    return http.post('messages/batch-update-status', { ids, status })
  },
}

export default messageApi
